import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import type { HistoryState } from '../type/history.type';

export const HistoryModel = Symbol('HistoryModel');

export type HistoryModel = AbstractModel<HistoryState>

@injectable()
export class HistoryModelImpl extends AbstractModel<HistoryState> implements HistoryModel {
    protected _modelData: HistoryState = {
        taskId: '',
        historyDetailTemp: {
            taskId: '',
            title: '',
        },
    };
}
